var exports = {
  "o": "xa15a2ab7--85b922--slider-wrapper",
};

module.exports = exports;
